/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, Inject, Injectable } from '@angular/core';
import { LOGGED_IN_CONTEXT_SERVICE } from '@irian-ro/auth-shared-module';
import { LoggedInContextService } from './logged-in-context.service';
import { Observable } from 'rxjs';
import { LoggedInContext } from './logged-in-context.model';
import { map } from 'rxjs/operators';
import { DelContactEmailableResourceService } from '@well/resource-services';

@Injectable({
  providedIn: 'root',
})
export class WellContextService {
  constructor(@Inject(LOGGED_IN_CONTEXT_SERVICE) private loggedInContextService: LoggedInContextService) {}

  getLoggedInContext(): Observable<LoggedInContext> {
    return this.loggedInContextService.getLoggedInContext();
  }

  delContactResourceService = inject(DelContactEmailableResourceService);

  getLoggedInCompanyContacts() {
    return this.delContactResourceService
      .getAllPublicContactsForCompany(this.loggedInContextService.getStoredLoggedInContext().legalEntityUuid)
      .pipe(map((contacts) => contacts.map((contact: any) => contact.uuid)));
  }

  isEmailAuth() {
    return this.loggedInContextService.getLoggedInContext().pipe(
      map((data) => {
        return data.loggedInUser?.authType === 'authEmail';
      })
    );
  }

  isServiceProviderWithEmailAuthType() {
    return this.loggedInContextService.getLoggedInContext().pipe(
      map((data) => {
        return data.loggedInUser?.authType === 'authEmail' && data.serviceProvider;
      })
    );
  }
}
